import type { FaireProductEntity } from "../../entity_types/product";

export const p_g6ywte78vr: FaireProductEntity = {
  token: "p_g6ywte78vr",
  type: "product",
  name: "Matches \u2022 American Flag USA \u2022 Home Decor for Candles",
  brandName: "Most Amazing",
  imageUrl:
    "https://cdn.faire.com/fastly/07359180d48fa9afa127c8147cc86e089f8773386a998442ef3d4d1557e06cbd.jpeg",
  priceDollars: 1.2,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/a678a165eeb47f07cd22ef320ce119ccb5269078e71f9d6f8fb4ed478c2db8cd.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
